import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import MobilePageHeader from "@/components/Mobile/Header/PageTitle";
import Image from "next/image";

// CSR banner
const CSRBanner = ({ isMobile }: { isMobile: boolean }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const handleBack = () => {
    if (window.location.hash === "#donate-now") {
      // 返回到上上个页面
      window.history.go(-2);
    } else {
      router.back();
    }
  };

  return (
    <div className="relative h-[800px] text-center">
      <Image
        src="/images/csr/csr_banner_bg.webp"
        alt="CSR Banner Background"
        fill
        className="-z-10 object-cover object-center"
      />
      {isMobile && <MobilePageHeader back={true} transparent={true} onBack={handleBack} />}
      {isMobile ? (
        <div className="mb-10 mt-[70px] text-4xl font-bold text-[#191919]">
          {t("csr.banner_title1")}
          <p className="mt-4">{t("csr.banner_title2")}</p>
        </div>
      ) : (
        <div className="mb-10 mt-[157px] text-7xl font-bold text-[#191919]">
          {t("csr.banner_title1")} <span className="relative -top-2">|</span> {t("csr.banner_title2")}
        </div>
      )}
      <div className={`text-[#4c4c4c] ${isMobile ? "text-base" : "text-xl"}`}>{t("csr.banner_desc")}</div>
    </div>
  );
};
export default CSRBanner;
